"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".root_1bbe0511{background-color:" }, { "theme": "whiteTranslucent40", "defaultValue": "rgba(255,255,255,.4)" }, { "rawString": ";position:absolute;bottom:0;left:0;right:0;top:0}.root_1bbe0511.rootIsNone_1bbe0511{visibility:hidden}.root_1bbe0511.rootIsDark_1bbe0511{background-color:" }, { "theme": "blackTranslucent40", "defaultValue": "rgba(0,0,0,.4)" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.root_1bbe0511{border:1px solid WindowText}}\n" }]);
exports.root = "root_1bbe0511";
exports.rootIsNone = "rootIsNone_1bbe0511";
exports.rootIsDark = "rootIsDark_1bbe0511";
//# sourceMappingURL=Overlay.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/Overlay/Overlay.scss.js
// module id = 349
// module chunks = 0